import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShareState } from "type/store/shareSlice";

const initialState: ShareState = {
  shareId: null,
  isTracking: false,
  apiError: null,
  apiErrorType: null,
};

const shareSlice = createSlice({
  name: "share",
  initialState,
  reducers: {
    setShareId: (state, action: PayloadAction<string | null>) => {
      state.shareId = action.payload;
    },
    setIsTracking: (state, action: PayloadAction<boolean>) => {
      state.isTracking = action.payload;
    },
    setApiError: (state, action: PayloadAction<string | null>) => {
      state.apiError = action.payload;
    },
    setApiErrorType: (state, action: PayloadAction<string | null>) => {
      state.apiErrorType = action.payload;
    },
    clearShare: (state) => {
      state.shareId = null;
      state.isTracking = false;
    },
  },
});

export const {
  setShareId,
  setIsTracking,
  clearShare,
  setApiError,
  setApiErrorType,
} = shareSlice.actions;
export default shareSlice;
